import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import StorefrontLayout from "@/components/StorefrontLayout";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleSignIn() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function CustomerLogin() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await api.post("/auth/customer/login", { email, password });
      setUser({ ...r.data, role: "customer" });
      nav("/account");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Invalid email or password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <StorefrontLayout>
      <section className="max-w-md mx-auto px-6 py-20">
        <div className="label-mono mb-3">/ SIGN IN</div>
        <h1 className="font-display text-5xl font-medium tracking-tight">Welcome back.</h1>
        <p className="mt-3 text-base" style={{ color: "var(--ink-soft)" }}>Continue to your account.</p>

        <button data-testid="google-signin-btn" onClick={googleSignIn} className="btn-ghost w-full justify-center mt-8">
          <span className="font-mono-ui mr-1">G</span> Continue with Google
        </button>
        <div className="my-6 flex items-center gap-3 text-xs" style={{ color: "var(--ink-mute)" }}>
          <div className="h-px flex-1" style={{ background: "var(--rule)" }} /> OR <div className="h-px flex-1" style={{ background: "var(--rule)" }} />
        </div>

        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <span className="label-mono">Email</span>
            <input data-testid="cust-login-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full px-4 py-3 rounded-lg outline-none"
              style={{ background: "var(--paper)", border: "1px solid var(--rule)" }} />
          </label>
          <label className="block">
            <span className="label-mono">Password</span>
            <input data-testid="cust-login-password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full px-4 py-3 rounded-lg outline-none"
              style={{ background: "var(--paper)", border: "1px solid var(--rule)" }} />
          </label>
          {err && <div data-testid="cust-login-err" className="text-sm font-mono-ui" style={{ color: "var(--accent)" }}>{err}</div>}
          <button data-testid="cust-login-submit" disabled={busy} className="btn-pill w-full justify-center">
            {busy ? "Signing in…" : "Sign in →"}
          </button>
        </form>

        <p className="mt-6 text-sm" style={{ color: "var(--ink-soft)" }}>
          New here? <Link to="/signup" className="underline">Create an account</Link>
        </p>
      </section>
    </StorefrontLayout>
  );
}
